import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '../services/user.service';
import { catchError, map, of } from 'rxjs';

/**
 * Route guard that ensures the user is authenticated and has a user type assigned.
 * If the user is already cached, checks user type synchronously. Otherwise fetches
 * the current user first. Redirects to '/' in all failure cases.
 */
export const authGuard: CanActivateFn = () => {
  const userService: UserService = inject(UserService);
  const router: Router = inject(Router);

  if (userService.currentUser) {
    if (!userService.hasUserType()) {
      router.navigateByUrl('/');
      return false;
    }
    return true;
  }

  return userService.getCurrentUser().pipe(
    map((user) => {
      if (!user) {
        router.navigateByUrl('/');
        return false;
      }
      if (!user.userType) {
        router.navigateByUrl('/');
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigateByUrl('/');
      return of(false);
    }),
  );
};
